import { render, staticRenderFns } from "./activitiesBanner.vue?vue&type=template&id=0ed45efc&scoped=true"
import script from "./activitiesBanner.vue?vue&type=script&lang=ts"
export * from "./activitiesBanner.vue?vue&type=script&lang=ts"
import style0 from "./activitiesBanner.vue?vue&type=style&index=0&id=0ed45efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed45efc",
  null
  
)

export default component.exports